export const pendingBookings = {
  configTitle: "إعداد الحجوزات المباشرة",
  configText:
    "فعّل الحجوزات المباشرة لتدير من هنا المدفوعات المعلّقة وطلبات الحجز الخاصة بضيوفك.",
  reminderLabel: "تذكير:",
  reminderReasonIntent: "دفعة معلّقة من",
  reminderReasonUnassigned: "تخصيص غرفة إلى",
  reminderReasonRequest: "طلب بانتظار المراجعة من",
  combined: "مجمّعة · {count} غرفة",
  expired: "منتهٍ",
  toastSuccessTitle: "نجاح",
  toastErrorTitle: "خطأ",
  toastWarningTitle: "تنبيه",
};
